import firebase from 'firebase'
import 'firebase/firestore' // tuntuu toimivan ilmankin mutta eikö muka tarvita?

// Initialize Firebase
var config = {
  // apiKey: 'AIzaSyBEwbWXIBrJEUqc9AUTOWev9B9jhDPZv84',
  // apiKey: 'AIzaSyAYKDm09mNKv7GR46-cvzB9O5VnOgSMxDk',
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: 'tty-cookbook.firebaseapp.com',
  databaseURL: 'https://tty-cookbook.firebaseio.com',
  projectId: 'tty-cookbook',
  storageBucket: 'tty-cookbook.appspot.com',
  messagingSenderId: '255894482880'
}

const firebaseApp = firebase.initializeApp(config)

// Required for versions 4.13->
firebase.firestore().settings({ timestampsInSnapshots: true })

// Export firestore database
export default firebaseApp.firestore()
